export const TagReturnIcon: React.FC<React.ComponentProps<"svg">> = ({
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.49902 5.99976C7.94674 5.99976 7.49902 6.44747 7.49902 6.99976C7.49902 7.55204 7.94674 7.99976 8.49902 7.99976C9.04773 7.99976 9.50902 7.55265 9.50902 6.99976C9.50902 6.44686 9.04773 5.99976 8.49902 5.99976Z"
        fill="currentColor"
      />
      <path
        d="M2.49902 1.99976C2.49902 1.44747 2.94674 0.999756 3.49902 0.999756H13.499C13.7642 0.999756 14.0186 1.10511 14.2061 1.29265L22.7982 9.88475C23.357 10.4468 23.6706 11.2072 23.6706 11.9998C23.6706 12.7923 23.357 13.5527 22.7982 14.1148L22.7961 14.1169L14.352 22.5633C13.9674 22.9481 13.3459 22.9551 12.9526 22.5792V22.5792C12.5467 22.1911 12.5395 21.5451 12.9365 21.148L21.3798 12.7048C21.5655 12.5175 21.6706 12.2635 21.6706 11.9998C21.6706 11.736 21.5655 11.482 21.3798 11.2948L13.0848 2.99976H4.49902V10.9998C4.49902 11.552 4.05131 11.9998 3.49902 11.9998V11.9998C2.94674 11.9998 2.49902 11.552 2.49902 10.9998V1.99976Z"
        fill="currentColor"
      />
      <path
        d="M10.2476 18.2487C10.7999 18.2487 11.2476 17.801 11.2476 17.2487C11.2476 16.6964 10.7999 16.2487 10.2476 16.2487H5.34078L6.38075 15.2087C7.2927 14.2968 5.87848 12.8826 4.96653 13.7945L2.23124 16.5298C1.8421 16.9062 1.82314 17.5747 2.21926 17.956L4.96653 20.7033C5.87848 21.6152 7.2927 20.201 6.38075 19.2891L5.34039 18.2487H10.2476Z"
        fill="currentColor"
      />
    </svg>
  );
};
